/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {WorkflowDefineFormComponent as ɵc} from './workflowdefine-form/workflowdefine-form.component';
export {WorkflowDefineComponent as ɵb} from './workflowdefine.component';
export {declaration as ɵa} from './workflowdefine.module';
export {WorkflowDefineRoutes as ɵd} from './workflowdefine.routing';